import React, { useMemo } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { format } from 'date-fns'

const PerformanceChart = ({ trades }) => {
  const chartData = useMemo(() => {
    if (!trades.length) return []
    const sortedTrades = [...trades].sort((a, b) => new Date(a.entry_time) - new Date(b.entry_time))
    let cumulativePnL = 0
    return sortedTrades.map((trade, index) => {
      cumulativePnL += trade.pnl || 0
      return {
        date: format(new Date(trade.entry_time), 'MMM dd'),
        pnl: cumulativePnL,
        trade: index + 1
      }
    })
  }, [trades])

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Performance Curve</h3>
      {chartData.length === 0 ? (
        <div className="h-64 flex items-center justify-center text-gray-500">
          <div className="text-center">
            <p>No trading data available</p>
            <p className="text-sm mt-1">Start adding trades to see your performance curve</p>
          </div>
        </div>
      ) : (
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="date" stroke="#6b7280" fontSize={12} />
              <YAxis 
                stroke="#6b7280" 
                fontSize={10} 
                tickFormatter={(value) => `Rp ${value.toLocaleString('id-ID')}`} 
              />
              <Tooltip 
                formatter={(value) => [`Rp ${value.toLocaleString('id-ID')}`, 'P&L']}
                labelFormatter={(label) => `Date: ${label}`}
                contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
              />
              <Line type="monotone" dataKey="pnl" stroke="#3b82f6" strokeWidth={2} dot={{ fill: '#3b82f6' }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  )
}

export default PerformanceChart